import React from 'react';
import { useParams,useLocation } from 'react-router-dom';
import AppLayout from '../../layout/app.layout';
import ListVideos from '../../components/content/list-videos.component';
import PAGE_TITLE_LIST from '../../config/page-title.config';

const ContentVideosView = () => {
  const { id } = useParams();
  const { pathname } = useLocation();
  const pageTitle = PAGE_TITLE_LIST.CONTENT_VIDEOS;
  const contentFrom = pathname.split("/")[3] || 'video';

  return (
    <AppLayout pageTitle={pageTitle}>
      {contentFrom === 'season' && (
        <ListVideos seasonId={id}/>)}
      {contentFrom === 'show'&& (
        <ListVideos showId={id}/>)}
      {contentFrom === 'video'&& (
        <ListVideos />)}
    </AppLayout>
  );
};

export default ContentVideosView;
